import { CantileverButton } from 'components/CantileverButton'
import { X } from 'lucide-react'
import React from 'react'
import styled from 'styled-components'

const StyledKeywordContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
  padding: 0.5rem;
  background-color: ${({ theme }) => theme.forecast.defaultButton};
  border-radius: 4px;
  align-items: center;
  width: 50%;
`

const KeywordChip = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.25rem 0.5rem;
  background-color: ${({ theme }) => theme.forecast.hoverButton};
  border-radius: 4px;
  font-size: 0.75rem;
  color: ${({ theme }) => theme.forecast.activeText};
  cursor: default;
`

const RemoveButton = styled(CantileverButton)`
  min-height: 1rem;
  width: 1rem;
`

const RemoveIcon = styled(X)`
  width: 0.75rem;
  height: 0.75rem;
`

const PlaceholderText = styled.span`
  color: ${({ theme }) => theme.forecast.defaultText};
  opacity: 0.5;
  font-size: 0.875rem;
  font-style: italic;
  cursor: default;
`

interface KeywordContainerProps {
  keywords: string[]
  onRemoveKeyword: (keyword: string) => void
  placeholderText: string
}

export const KeywordContainer: React.FC<KeywordContainerProps> = ({
  keywords,
  onRemoveKeyword,
  placeholderText,
}) => {
  return (
    <StyledKeywordContainer>
      {keywords.length === 0 ? (
        <PlaceholderText>{placeholderText}</PlaceholderText>
      ) : (
        keywords.map((keyword) => (
          <KeywordChip key={keyword}>
            {keyword}
            <RemoveButton
              iconOnly
              ghost
              onClick={() => onRemoveKeyword(keyword)}>
              <RemoveIcon />
            </RemoveButton>
          </KeywordChip>
        ))
      )}
    </StyledKeywordContainer>
  )
}
